import React, { useState } from 'react';
import { Button, notification, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';

import { useAppDispatch, useAppSelector } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import { useQuery } from 'hooks/useQuery';
import { useDeepEffect } from 'utils/useDeepEffect';
import { StickyConfirmModal } from 'components/modals/StickyConfirmModal';
import {
  loadPurchasesList,
  setUnPublishPurchase,
  deletePurchasesItem,
} from 'store/slices/purchases/actions';
import { PageTitles } from 'constants/pageTitles';
import { StatusesEnum } from 'constants/status';
import { canBeUnPublished } from 'utils/rights';
import { IPurchasesItemResponse } from 'store/slices/purchases/interfaces';

import { Filters } from './components/Filters';
import { ListTable } from './components/ListTable';

export const List = () => {
  const [sort, setSort] = React.useState(null);
  const dispatch = useAppDispatch();
  const query = useQuery();

  const { list, total, limit } = useAppSelector(state => state.purchases);
  const { b2bUrl } = useAppSelector(state => state.configSlice);
  const loadPurchases = () => {
    dispatch(
      loadPurchasesList({
        ...query,
        sort,
      })
    );
  };

  const [modalIsOpen, setModalIsOpen] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);

  useDeepEffect(() => {
    loadPurchases();
  }, [query, sort]);

  const modalCloseHandler = () => {
    setModalIsOpen(null);
    setCurrentItem(null);
  };

  const handleUnPublish = async id => {
    await dispatch(setUnPublishPurchase(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно снята с публикации',
        });
        loadPurchases();
        modalCloseHandler();
      });
  };

  const handleDelete = async id => {
    await dispatch(deletePurchasesItem(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно удалена',
        });
        loadPurchases();
        modalCloseHandler();
      });
  };

  const getActions = (item: IPurchasesItemResponse) => [
    item.status === StatusesEnum.PUBLISHED && {
      key: 'onSite',
      label: (
        <a
          target='_blank'
          rel='noreferrer nofollow'
          href={`${b2bUrl}/purchases/${item.id}`}
        >
          На сайте
        </a>
      ),
    },
    {
      key: 'edit',
      label: <Link to={`/purchases/${item.id}/edit`}>Редактировать</Link>,
    },
    canBeUnPublished(item) && {
      key: 'unPublish',
      label: <Typography.Text>Снять с публикации</Typography.Text>,
      onClick: () => handleUnPublish(item.id),
    },
    {
      key: 'remove',
      label: <Typography.Text type='danger'>Удалить</Typography.Text>,
      onClick: () => {
        setModalIsOpen('remove');
        setCurrentItem(item);
      },
    },
  ];

  return (
    <MainLayout
      pageTitle={PageTitles.purchases}
      extraButtonsList={[
        <Link key={1} to='/purchases/add'>
          <Button type='primary'>Создать</Button>
        </Link>,
      ]}
      aside={<Filters />}
    >
      <Content>
        <ListTable
          data={list}
          total={total}
          getActions={getActions}
          limit={limit}
          setSort={setSort}
        />
      </Content>
      {currentItem?.id && (
        <>
          {modalIsOpen === 'remove' && (
            <StickyConfirmModal
              isOpen={modalIsOpen === 'remove'}
              onRequestClose={modalCloseHandler}
              title='Удаление закупки'
              okText='Удалить'
              text={
                <div>
                  Вы хотите убрать с портала и переместить в Корзину закупку{' '}
                  <Typography.Text strong>
                    {currentItem.name || ''}
                  </Typography.Text>
                  ?
                </div>
              }
              onSubmit={() => handleDelete(currentItem?.id)}
              okButtonProps={{ danger: true }}
            />
          )}
        </>
      )}
    </MainLayout>
  );
};
